(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Notification', Notification)
        .factory('SentNotifications', SentNotifications);

    Notification.$inject = ['$resource', 'DateUtils'];

    function Notification ($resource, DateUtils) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pushDate = DateUtils.convertDateTimeFromServer(data.pushDate);
                        data.expiryDate = DateUtils.convertDateTimeFromServer(data.expiryDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    SentNotifications.$inject = ['$resource'];

    function SentNotifications ($resource) {
        var resourceUrl =  'api/sent-notifications';
        return $resource(resourceUrl, {}, {
        });
    }
})();
